export const utcInitialDate = {
  year: 2021,
  month: 3,
  day: 10,
  hours: 12,
  seconds: 0,
  milliseconds: 0,
  minutes: 0,
};
